export default __webpack_public_path__ + "static/media/Asset 12.13afd42b.png";